import React from 'react'
import { Menu } from '@newspacebpo/mf_protocolo_bfveic'
const MenuPage = (props) => {
    return (
            <Menu {...props}/>
    );
};

export { MenuPage };